import { render, staticRenderFns } from "./PassWordReSet.vue?vue&type=template&id=2a3a832c&"
import script from "./PassWordReSet.vue?vue&type=script&lang=js&"
export * from "./PassWordReSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports